import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core'
import { CodeLookup } from 'src/app/models/api.model'
import { OptionsService } from 'src/app/services/common/options.service'

@Component({
  selector: 'app-multi-dropdown-add-option',
  templateUrl: './multi-dropdown-add-option.component.html',
  styleUrls: ['./multi-dropdown-add-option.component.scss']
})
export class MultiDropdownAddOptionComponent implements OnInit {
  @Input() options: CodeLookup[] = []
  @Input() label: string = ''
  @Input() selectedOptions: any[] = []

  @Output() optionSelected = new EventEmitter<string[]>()
  @Output() newOptionAdded = new EventEmitter<CodeLookup>()

  dropdownSettings = {}
  addingNewOption = false
  newOption = { key1: '', key2: '' }

  constructor(private optionsService: OptionsService) {}

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key2',
      textField: 'key1',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    }
  }

  onItemSelect(item: any) {
    this.optionSelected.emit(this.selectedOptions)
  }

  onItemDeSelect(item: any) {
    this.optionSelected.emit(this.selectedOptions)
  }

  onSelectAll(items: any) {
    this.optionSelected.emit(items)
  }

  onDeSelectAll(items: any) {
    this.optionSelected.emit(items)
  }

  addNewOption() {
    if (this.newOption.key1) {
      const key1 = this.newOption.key1
      const key2 = this.newOption.key1.toUpperCase().replace(/ /g, '_')
      const newCodeLookup: CodeLookup = {
        keyCode: this.getMaxKeyCode() + 1,
        lkupCode: this.options[0]?.lkupCode || '',
        description: null,
        key1: key1,
        key2: key2,
        key3: '',
        key4: '',
        key5: '',
        status: 'Active'
      }

      this.optionsService.saveOption(newCodeLookup).subscribe(res => {
        if (res) {
          this.selectedOptions.push(newCodeLookup)
          this.newOptionAdded.emit(newCodeLookup)
          this.optionSelected.emit(this.selectedOptions)
          this.addingNewOption = false
          this.newOption = { key1: '', key2: '' }
        }
      })
    }
  }

  cancelNewOption() {
    this.addingNewOption = false
    this.newOption = { key1: '', key2: '' }
  }

  getMaxKeyCode(): number {
    return this.options.length > 0 ? Math.max(...this.options.map(o => o.keyCode)) : 0
  }
}
